import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'components/fields'

const ParticipantLevelRegister = ({ levels }) => (
  <Select
    label="Award Level"
    name="awards[0].awardLevel.value"
    options={levels}
  />
)

ParticipantLevelRegister.propTypes = {
  levels: PropTypes.array
}

export default ParticipantLevelRegister
